
import type { AppState } from "@/types/SharedTypes";
import { useCallback, useState, type PropsWithChildren } from "react";
import { AppStateContext } from "./AppStateContext";
import { useBenchmark } from "./BenchmarkContext";

export const AppStateProvider = ({ children }: PropsWithChildren) => {
    const { stopBenchmark } = useBenchmark();
    const [appState, setAppState] = useState<AppState>("initializing");
    const urlPath = window.location.pathname;

    const setAppStateWrapper = useCallback((newState: AppState) => {
        if (["showtemplate", "done"].includes(newState)) {
            stopBenchmark();
        }
        setAppState(newState);
    }, [stopBenchmark]);
    return (
        <AppStateContext.Provider value={{ appState, urlPath, setAppState: setAppStateWrapper }}>
            {children}
        </AppStateContext.Provider>
    );
};
